import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Collections } from "@graylog/enterprise-api";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
export const COLLECTION_ENTITIES_QUERY_KEY = "collection_entities";
export const keyFn = (collectionId, searchParams) => [
  COLLECTION_ENTITIES_QUERY_KEY,
  collectionId,
  searchParams
];
export const fetchPaginatedCollectionEntities = async (collectionId, searchParams) => Collections.getEntitiesPage(
  searchParams.sort.attributeId,
  collectionId,
  searchParams.page,
  searchParams.pageSize,
  searchParams.query,
  FiltersForQueryParams(searchParams.filters),
  searchParams.sort.direction
).then(({ elements, query, attributes, pagination: { count, total, page, per_page: perPage } }) => ({
  list: elements,
  attributes,
  pagination: {
    count,
    total,
    page,
    perPage,
    query
  }
}));
const useCollectionEntities = (collectionId, searchParams, { enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: keyFn(collectionId, searchParams),
    queryFn: () => defaultOnError(
      fetchPaginatedCollectionEntities(collectionId, searchParams),
      "Loading Collection Entities failed with status",
      "Could not load Collection Entities"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading,
    refetch
  };
};
export default useCollectionEntities;
